/**
 * Helpers de telefone brasileiro (DDD + número, sem DDI).
 */

export function onlyDigits(value: unknown): string {
  return String(value ?? '').replace(/\D/g, '');
}

/**
 * Remove o código do país de um número que veio em formato internacional.
 *
 * O autofill do navegador e os gerenciadores de senha costumam devolver o
 * telefone como "+55 55 98439-7414" / "005555984397414". Como a máscara aceita
 * no máximo 11 dígitos, o "55" do DDI seria consumido como DDD e os dígitos
 * finais seriam descartados em silêncio.
 *
 * Só remove prefixos quando sobram dígitos demais, então um número nacional
 * legítimo com DDD 55 (RS) nunca é alterado.
 */
export function stripCountryCode(digits: string): string {
  let value = digits;
  if (value.length > 11 && value.startsWith('00')) value = value.slice(2);
  if (value.length > 11 && value.startsWith('55')) value = value.slice(2);
  if (value.length > 11 && value.startsWith('0')) value = value.slice(1);
  return value;
}

/**
 * Valida DDD + número: 10 dígitos (fixo) ou 11 dígitos (celular, iniciado em 9).
 */
export function isValidPhoneBr(digits: string): boolean {
  if (digits.length !== 10 && digits.length !== 11) return false;
  if (Number(digits.slice(0, 2)) < 11) return false;
  if (digits.length === 11 && digits[2] !== '9') return false;
  return true;
}
